/* Elshorafa Co 2026-09-30: card quick add into the theme cart drawer, and swipe dots on touch screens. 2026-10-02 v1.8: wishlist hearts */
(function () {
  if (window.__ecCards) return; window.__ecCards = true;
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-ec-quick]')) return;
    e.preventDefault();
    var btn = f.querySelector('button'), label = btn.textContent, ar = document.documentElement.lang.indexOf('ar') === 0;
    btn.disabled = true; btn.textContent = ar ? 'جاري الإضافة' : 'Adding';
    var cd = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(f.querySelector('[name=id]').value, 10), quantity: 1 }] };
    if (cd) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false; btn.textContent = label;
        if (res.status) { btn.textContent = res.description || label; setTimeout(function () { btn.textContent = label; }, 2500); return; }
        if (cd && typeof cd.renderContents === 'function' && res.sections) { try { cd.classList.remove('is-empty'); cd.renderContents(res); return; } catch (x) {} }
        location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      })
      .catch(function () { f.submit(); });
  });
  function dots(root) {
    (root || document).querySelectorAll('.ec-card__track').forEach(function (t) {
      if (t.__ec) return; t.__ec = true;
      var d = t.parentNode.querySelectorAll('.ec-card__dots i'); if (!d.length) return;
      var set = function () { var i = Math.round(Math.abs(t.scrollLeft) / (t.clientWidth || 1)); d.forEach(function (x, n) { x.style.background = n === i ? '#54001c' : ''; }); };
      t.addEventListener('scroll', set, { passive: true }); set();
    });
  }
  /* 2026-10-02 v1.8: wishlist hearts. Same list the wishlist page reads, so a saved piece shows there. */
  var WKEY = 'shopify-wishlist';
  function wl() { try { var s = localStorage.getItem(WKEY); return s ? s.split(',').filter(Boolean) : []; } catch (x) { return []; } }
  function wlSave(a) { try { if (a.length) localStorage.setItem(WKEY, a.join(',')); else localStorage.removeItem(WKEY); } catch (x) {} }
  function hearts(root) {
    var list = wl();
    (root || document).querySelectorAll('[data-ec-heart]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-ec-heart')) > -1;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ec-heart]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-ec-heart'), list = wl(), i = list.indexOf(h), added = i === -1;
    if (added) list.push(h); else list.splice(i, 1);
    wlSave(list); hearts();
    document.querySelectorAll('dtx-wish-count').forEach(function (c) { c.setAttribute('count', list.length); });
    if (typeof window.dtShowWishlistToast === 'function') window.dtShowWishlistToast(added);
  });
  window.addEventListener('pageshow', function () { hearts(); });
  window.addEventListener('storage', function (e) { if (e.key === WKEY) hearts(); });
  window.ecCardsInit = function (root) { dots(root); hearts(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { dots(); hearts(); }); else { dots(); hearts(); }
})();
